// Pages that show the shared date FilterBar. A page belongs here when its
// data is windowed to the shared range. Static explainers (methodology),
// builders (export, exec summary) and the fixed-window pages (factor-detail)
// do their own thing and would be confused by a shared date range. Users IS
// date-bearing: the roster's engagement columns (sims sent, click rate, 2nd
// stage, reported, courses sent, completion, avg score) window to the selected
// range; only the risk score / band stay on the fixed 180-day snapshot. Sim and
// course detail window their KPIs and recipients too, so the period mustn't be
// hidden there (BD-1170). The drill-down tables (all sims, all courses, high
// click users, outstanding users) window their rows to the shared range, so
// they show it too (NBD-26).
export const DATE_BEARING_PAGES = new Set([
    'sims', 'courses', 'dwm', 'users', 'user-detail', 'meta-list', 'meta-detail', 'sim-detail', 'course-detail',
    'send-history', 'course-send-log', 'flagged-sims',
    'all-sims-table', 'all-courses-table', 'high-risk-users', 'outstanding-users',
]);

// user-detail uses the simple variant: date pickers only, no quick-period pills.
export const SIMPLE_FILTER_PAGES = new Set(['user-detail']);
